import { Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { UitkCard, UitkCardContent, UitkCardImageLayout, UitkCardMedia } from "uitk-react-cards";
import * as React from "react";
import { CardMediaOverallInfo } from "./CardMediaOverallInfo";
import { FeaturedReviewContent } from "./FeaturedReviewContent";
import { TrackedLink } from "src/components/utility/analytics/TrackedLink";
import { Description } from "./Description";
import { observer } from "mobx-react";
import { HotelsStore } from "src/stores/HotelsStore";

interface HotelCardProps {
  hotel: Hotel;
  index: number;
  callToAction?: string;
  callToActionHotelName?: string;
  context: ExtendedContextStore;
  CardContent?: () => JSX.Element;
  className?: string;
  moduleName?: string;
  priceStrategy?: string;
  isMobile?: boolean;
  hotels?: HotelsStore;
  gallery?: {
    src: string;
    alt: string;
  }[];
  showGuestRating?: boolean;
  displayBadges?: boolean;
  withBorder?: boolean;
}

export const HotelCard: React.FC<HotelCardProps> = observer(
  ({
    hotel,
    index,
    callToAction,
    context,
    CardContent,
    className,
    moduleName = "hotels",
    priceStrategy,
    isMobile,
    gallery,
    showGuestRating,
    displayBadges,
    withBorder
  }) => {
    const { hotelName, hotelInfositeUrl } = hotel;
    const imageLayout = isMobile ? undefined : UitkCardImageLayout.LEFT_FULLBLEED;

    return (
      <UitkCard className={className} imageLayout={imageLayout} withBorder={withBorder}>
        <UitkCardMedia>
          <CardMediaOverallInfo hotel={hotel} context={context} index={index} displayBadges={displayBadges} />
        </UitkCardMedia>
        <UitkCardContent>
          {CardContent && <CardContent />}
          <Description hotel={hotel} />
          <FeaturedReviewContent context={context} hotel={hotel} showGuestRating={showGuestRating} />
          <TrackedLink
            data-testid={`hotelcard-link-${index}`}
            className="uitk-card-link"
            moduleName={moduleName}
            rfrr="card"
            rel={getHotelLinkRel(callToAction)}
            href={hotelInfositeUrl}
          >
            {hotelName}
          </TrackedLink>
        </UitkCardContent>
      </UitkCard>
    );
  }
);

/**
 * In case of pinnedHSR or pinnedHSRDated, we need to generate a rel="nofollow" link
 * @param callToAction
 */
export const getHotelLinkRel = (callToAction?: string) => {
  return callToAction && callToAction.startsWith("pinnedHSR") ? "nofollow" : null;
};
